import { render, staticRenderFns } from "./DeviceDeleteDialog.vue?vue&type=template&id=6f28178c&scoped=true&"
import script from "./DeviceDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./DeviceDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28178c",
  null
  
)

export default component.exports